<template>
    <div class="three">
        <three-header
            :mode="mode"
            :current-state="currentState"
            @change-mode="changeMode"
            @modal3d-off="modal3dOff"
        />
        <div
            class="flex"
            style="position: relative"
        >
            <div>
                <div
                    ref="threeArea"
                    style="width:100vw; height:100vh"
                />
                <ball-info
                    v-if="mode!=='tunnel'"
                    :ball="ball"
                    :mode="mode"
                    :all-balls="allBalls"
                    :saved-balls="savedBalls"
                    :saved-standard-ball="savedStandardBall"
                    :base-ball-index="baseBallIndex"
                    :current-angle="currentAngle"
                    :slide-batx="slideBatx"
                    :slide-baty="slideBaty"
                    :slide-batz="slideBatz"
                    :slide-pitx="slidePitx"
                    :slide-pity="slidePity"
                    :slide-pitz="slidePitz"
                    :current-batter-point-set="currentBatterPointSet"
                    :batter-panel-state="batterPanelState"
                    :pitcher-panel-state="pitcherPanelState"
                    :PTReviewStandardBall="PTReviewStandardBall"
                    :three-list-sort-mode="threeListSortMode"
                    @close-batter-panel="closeBatterPanel"
                    @close-pitcher-panel="closePitcherPanel"
                    @change-batter-point="changeBatterPoint"
                    @change-pitcher-position="changePitcherPosition"
                    @change-pitcher-point="changePitcherPoint"
                    @get-saved-balls="getSavedBalls"
                    @get-saved-standard-balls="getSavedStandardBalls"
                    @change-ward="changeWard"
                    @reset-ward="resetWard"
                    @submit-batter-position="submitBatterPosition"
                    @submit-batter-point="submitBatterPoint"
                    @submit-pitcher-position="submitPitcherPosition"
                    @submit-pitcher-point="submitPitcherPoint"
                    @open-search-modal="openSearchModal"
                    @toggle-saved-standard-ball="toggleSavedStandardBall"
                    @change-mode="changeMode"
                />
                <pitcher-controller
                    :ball="ball"
                    :mode="mode"
                    :all-balls="allBalls"
                    :saved-balls="savedBalls"
                    :saved-standard-ball="savedStandardBall"
                    :base-ball-index="baseBallIndex"
                    :current-angle="currentAngle"
                    :slide-batx="slideBatx"
                    :slide-baty="slideBaty"
                    :slide-batz="slideBatz"
                    :slide-pitx="slidePitx"
                    :slide-pity="slidePity"
                    :slide-pitz="slidePitz"
                    :current-batter-point-set="currentBatterPointSet"
                    :batter-panel-state="batterPanelState"
                    :pitcher-panel-state="pitcherPanelState"
                    :PTReviewStandardBall="PTReviewStandardBall"
                    :three-list-sort-mode="threeListSortMode"
                    @close-batter-panel="closeBatterPanel"
                    @close-pitcher-panel="closePitcherPanel"
                    @change-batter-point="changeBatterPoint"
                    @change-pitcher-position="changePitcherPosition"
                    @change-pitcher-point="changePitcherPoint"
                    @get-saved-balls="getSavedBalls"
                    @get-saved-standard-balls="getSavedStandardBalls"
                    @submit-batter-position="submitBatterPosition"
                    @submit-batter-point="submitBatterPoint"
                    @submit-pitcher-position="submitPitcherPosition"
                    @submit-pitcher-point="submitPitcherPoint"
                    @open-search-modal="openSearchModal"
                    @toggle-saved-standard-ball="toggleSavedStandardBall"
                />
                <batter-controller
                    v-if="mode!=='tunnel'"
                    :ball="ball"
                    :mode="mode"
                    :all-balls="allBalls"
                    :saved-balls="savedBalls"
                    :saved-standard-ball="savedStandardBall"
                    :base-ball-index="baseBallIndex"
                    :current-angle="currentAngle"
                    :slide-batx="slideBatx"
                    :slide-baty="slideBaty"
                    :slide-batz="slideBatz"
                    :slide-pitx="slidePitx"
                    :slide-pity="slidePity"
                    :slide-pitz="slidePitz"
                    :current-batter-point-set="currentBatterPointSet"
                    :batter-panel-state="batterPanelState"
                    :pitcher-panel-state="pitcherPanelState"
                    :PTReviewStandardBall="PTReviewStandardBall"
                    :three-list-sort-mode="threeListSortMode"
                    @close-batter-panel="closeBatterPanel"
                    @close-pitcher-panel="closePitcherPanel"
                    @change-batter-point="changeBatterPoint"
                    @change-pitcher-position="changePitcherPosition"
                    @change-pitcher-point="changePitcherPoint"
                    @get-saved-balls="getSavedBalls"
                    @get-saved-standard-balls="getSavedStandardBalls"
                    @change-ward="changeWard"
                    @reset-ward="resetWard"
                    @submit-batter-position="submitBatterPosition"
                    @submit-batter-point="submitBatterPoint"
                    @submit-pitcher-position="submitPitcherPosition"
                    @submit-pitcher-point="submitPitcherPoint"
                    @open-search-modal="openSearchModal"
                    @toggle-saved-standard-ball="toggleSavedStandardBall"
                    @change-mode="changeMode"
                />
                <div
                    v-if="mode==='tunnel'"
                    class="pichiTunnelBallInfo"
                >
                    <pichi-tunnel-ball-info
                        :ball="ball"
                        :mode="mode"
                        :all-balls="allBalls"
                        :saved-balls="savedBalls"
                        :saved-standard-ball="savedStandardBall"
                        :base="true"
                        :compar="false"
                        @toggle-saved-standard-ball="toggleSavedStandardBall"
                        @set-saved-standard-ball-p-tflag="setSavedStandardBallPTflag"
                        @delete-ball="deleteBall"
                        @compare-exist-check="compareExistCheck"
                        @set-pichi-tunnel-saved-standard-ball="setPichiTunnelSavedStandardBall"
                        @move-pt-2-search="movePT2Search"
                    />
                    <pichi-tunnel-ball-info-lists
                        :mode="mode"
                        :at-bat-balls="atBatBalls"
                        :all-balls="allBalls"
                        :playing="playing"
                        :now-i-d="threeParts.nowID"
                        :colors="ballColors"
                        :saved-balls="savedBalls"
                        :enable-multi-pos="enableMultiPos"
                        :base-ball-index="baseBallIndex"
                        @single-pitch="singlePitch"
                        @edit-multi-positions="editMultiPositions"
                        @remove-saved-ball="removeSavedBall"
                        @change-base-ball="changeBaseBall"
                        @toggle-saved-ball="toggleSavedBall"
                        @open-search-modal="openSearchModal"
                        @set-saved-ball-p-t-flag="setSavedBallPTFlag"
                        @delete-ball="deleteBall"
                        @compare-exist-check="compareExistCheck"
                        @set-pichi-tunnel-saved-ball="setPichiTunnelSavedBall"
                        @move-pt-2-search="movePT2Search"
                    />
                </div>
            </div>
        </div>
        <pichi-tunnel-info
            v-if="mode==='tunnel'"
            :pichi-rel-side="pichiTunnelWidth"
            :pichi-depth="pichiTunnelZ"
            :home-rel-side="homeTunnelWidth"
            :home-depth="homeTunnelZ"
        />
        <three-player
            :playing="playing"
            :mode="mode"
            :all-balls="allBalls"
            :now-max-frame="threeParts.nowMaxFrame"
            :now-frame="threeParts.nowFrame"
            :now-i-d="threeParts.nowID"
            @single-pitch="singlePitch"
            @multi-pitch="multiPitch"
            @single-slow="singleSlow"
            @multi-slow="multiSlow"
            @range-input="rangeInput"
            @prev="prev"
            @next="next"
        />
        <three-right
            :mode="mode"
            :batter-panel-state="batterPanelState"
            :pitcher-panel-state="pitcherPanelState"
            :current-angle="currentAngle"
            @open-batter-panel="openBatterPanel"
            @open-pitcher-panel="openPitcherPanel"
            @close-batter-panel="closeBatterPanel"
            @close-pitcher-panel="closePitcherPanel"
            @set-view-point-and-single-pitch="setViewPointAndSinglePitch"
            @set-view-point-and-multi-pitch="setViewPointAndMultiPitch"
        />
        <div v-if="mode!=='tunnel'">
            <three-list
                :mode="mode"
                :at-bat-balls="atBatBalls"
                :all-balls="allBalls"
                :playing="playing"
                :now-i-d="threeParts.nowID"
                :colors="ballColors"
                :saved-balls="savedBalls"
                :enable-multi-pos="enableMultiPos"
                :base-ball-index="baseBallIndex"
                :PTReviewBalls="PTReviewBalls"
                :three-list-sort-mode="threeListSortMode"
                @single-pitch="singlePitch"
                @edit-multi-positions="editMultiPositions"
                @remove-saved-ball="removeSavedBall"
                @change-base-ball="changeBaseBall"
                @toggle-saved-ball="toggleSavedBall"
                @open-search-modal="openSearchModal"
                @set-list-sort-mode="setListSortMode"
            />
            <div
                class="searchLayer"
                :class="{ opened: searchModalFlg }"
            />
            <three-search
                :init-mode="initMode"
                :mode="mode"
                :at-bat-balls="atBatBalls"
                :all-balls="allBalls"
                :playing="playing"
                :now-i-d="threeParts.nowID"
                :colors="ballColors"
                :saved-balls="savedBalls"
                :enable-multi-pos="enableMultiPos"
                :base-ball-index="baseBallIndex"
                :search-modal-flg="searchModalFlg"
                :current-saved-balls-id="currentSavedBallsId"
                :search-modal-type="searchModalType"
                :saved-standard-ball="savedStandardBall"
                :current-saved-standard-ball-id="currentSavedStandardBallId"
                @update-all="updateAll"
                @get-saved-balls="getSavedBalls"
                @get-saved-standard-balls="getSavedStandardBalls"
                @close-search-modal="closeSearchModal"
                @loading-on="loadingOn"
                @loading-off="loadingOff"
            />
        </div>
        <pichi-tunnel-tab
            v-if="mode==='tunnel'"
            :tab-data="tabData"
            @change-tab="changeTab"
            @delete-tab="deleteTab"
        />

        <div
            class="threeMessageModal"
            :class="{show: messageModalShow}"
            @click="messageModalOff($event)"
            v-html="message"
        />
        <div
            class="threeLoading"
            :class="{show: loadingShow}"
        >
            <p v-html="loadingMessage" />
            <div class="loading" />
        </div>
    </div>
</template>

<script>
import BallInfo from '@/components/3d/BallInfo'
import PichiTunnelBallInfo from '@/components/3d/PichiTunnelBallInfo.vue'
import PichiTunnelInfo from '@/components/3d/PichiTunnelInfo.vue'
import ThreeHeader from '@/components/3d/Header'
import ThreePlayer from '@/components/3d/Player'
import ThreeRight from '@/components/3d/Right'
import ThreeList from '@/components/3d/List'
import ThreeSearch from '@/components/3d/Search'
import PichiTunnelBallInfoLists from '@/components/3d/PichiTunnelBallInfoLists'
import PichiTunnelTab from '@/components/3d/PichiTunnelTab'
import PitcherController from '@/components/3d/PitcherController'
import BatterController from '@/components/3d/BatterController'
import Common3d from '@/components_common/3d'

export default {
    components: {
        BallInfo,
        PichiTunnelBallInfo,
        PichiTunnelInfo,
        PichiTunnelBallInfoLists,
        ThreeHeader,
        ThreePlayer,
        ThreeRight,
        ThreeList,
        ThreeSearch,
        PichiTunnelTab,
        PitcherController,
        BatterController
    },
    mixins: [Common3d],
    watch : {
        savedStandardBall : function(val) {
            if(this.threeListSortMode !== 2) {

                const data = val[0] || {}

                //console.log("change savedStandardBall",data,this.savedBalls)
                let query = {}
                let balls = []
                if(this.savedBalls?.length > 0){
                    this.savedBalls.forEach(ball => {
                        balls.push(ball.data.id)
                    })
                }
                if(balls.length > 0){
                    query.balls = balls.join(",")
                }

                this.$$router.replace({
                    params : {
                        ball: data?.id
                    },
                    query : query
                })
            }
        },
        PTReviewStandardBall : function(val){
            if(this.threeListSortMode === 2) {
                const data = val[0] || {}
                //console.log("change savedStandardBall", data, this.ball)
                if(data){
                    this.$$router.replace({
                        query : {
                            ballId : data.data.id
                        }
                    })
                }
                else{
                    this.$$router.replace({
                        query : {
                            ballId : undefined
                        }
                    })
                }
            }
        },
        ball : {
            handler(val) {
                if(val && val?.data.id) {
                    this.$$router.replace({
                        query : {
                            ballId : val?.data.id
                        }
                    })
                }
            },
            deep : true
        }
    },
    data () {
        return {
            setting: {
                // シーンの領域
                width: window.innerWidth,
                height: window.innerHeight,
                // カメラ設定のための変数
                fov: 50,  // 画角(視点から広がる角度)
                near: 1,  // クリッピング手前(近い場所のどこまでを描画するか)
                far: 5000 // クリッピグ奥(遠い場所をどこまで描画するか)
            },
        }
    },
}
</script>


<style scoped>
* {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -webkit-appearance: none;
}

input[type=text],
input[type=password],
input[type=radio],
input[type=checkbox],
input[type=email],
input[type=range] {
    -webkit-user-select: auto;
}

#threeArea {
    background-color: #000;
    text-align: center;
}

[type="range"] {
    width: 400px;
    height: 5px;
    background-color: rgba(255, 255, 255, 1.0);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2) inset;
    border-radius: 24px;
}

[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    z-index: 15;

    border: solid 1px #999;
    width: 25px;
    height: 25px;
    background-color: rgba(173, 173, 173, 1);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
}

[type="range"]:focus,
[type="range"]:focus::-webkit-slider-thumb,
[type="range"]:active,
[type="range"]:active::-webkit-slider-thumb {
    cursor: ew-resize;
    outline: none;
}

[type="range"]:active::-webkit-slider-thumb {
    background-color: rgba(255, 20, 147, 1.0);
}

[type="checkbox"] {
    border: solid 1px #999;
    background-color: #fff;
    width: 12px;
    height: 12px;
}

[type="checkbox"]:checked {
    opacity: 1;
    background: #ff0000;
}

.ballController p {
    height: 44px;
    line-height: 44px;
    padding: 0 15px;
}

.cameraController p {
    color: #fff;
    background-color: rgba(204, 204, 204, 0.5);
    padding: 8px;
}

/* メッセージモーダル */
.threeMessageModal {
    position: absolute;
    left: 5%;
    top: 40%;
    z-index: 1001;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    visibility: hidden;
    -webkit-transition: .3s;
    transition: .3s;
    width: 90%;
    padding: 10px;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
    color: #fff;
    font-size: 1.6rem;
    opacity: 0;
    line-height: 140%;
}

.threeMessageModal.show {
    visibility: visible !important;
    opacity: 1 !important;
}

/* ローディング */
.threeLoading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1001;
    text-align: center;
    display: none;
    background: rgba(0, 0, 0, 0.75);
}

.threeLoading.show {
    display: block;
}

.threeLoading p {
    position: absolute;
    left: 50%;
    top: 53%;
    width: 400px;
    padding: 30px;
    margin-left: -230px;
    text-align: center;
    color: #fff;
    font-size: 1.8rem;
    line-height: 150%;
}

.threeLoading img {
    margin-top: 45vh;
    width: 40px;
    height: 40px;
}

.threeLoading .loading {
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-top: 6px solid rgba(255, 255, 255, 0.5);
    border-right: 6px solid rgba(255, 255, 255, 0.5);
    border-bottom: 6px solid rgba(255, 255, 255, 0.5);
    border-left: 6px solid #fff;
    transform: translateZ(0);
    animation: loading 0.8s infinite linear;
    overflow: hidden;
    text-indent: 500%;
    white-space: nowrap;
}

.threeLoading .loading,
.threeLoading .loading:after {
    width: 70px;
    height: 70px;
    border-radius: 100%;
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.searchLayer {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: none;
    background: rgba(0, 0, 0, 0.65);
}

.searchLayer.opened {
    display: block;
}

.PTReviewBtnContainer {
    position: absolute;
    right: 84px;
    bottom: 60px;
    width: 250px;
}

.PTReviewBtnContainer button {
    display: block;
    width: 100%;
    padding: 5px;
    margin-top: 5px;
    border: none;
    color: #fff;
    font-size: 12px;
    background: rgba(68, 68, 68, 0.85);
}
</style>
